import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async () => {
    const response = await apiCustom.get("product-show");
    return response.data?.data?.product;
  }
);

export const fetchPublicProducts = createAsyncThunk(
  "products/fetchPublicProducts",
  async () => {
    const response = await apiCustom.get("product-public-show");
    return response.data?.data?.product;
  }
);
export const createProducts = createAsyncThunk(
  "products/createProducts",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/product-create", newPost, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updateProducts = createAsyncThunk(
  "products/updateProducts",
  async ({ id, newPost }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/product-update/${id}`, newPost);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const deleteProducts = createAsyncThunk(
  "products/deleteProducts",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete(`/product/${id}`);
      return { response };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
// export const getProductsByCompanyId = createAsyncThunk(
//   "products/getProductsByCompanyId",
//   async (id, { rejectWithValue }) => {
//     try {
//       const response = await apiCustom.get(`/product-show-company-id/${id}`);
//       return response.data.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
//     }
//   }
// );

const productsSlice = createSlice({
  name: "products",
  initialState: {
    products: [],
    publicProducts: [],
    status: "idle",
    publicProductsStatus: "idle",
    error: null,
    publicProductError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.products = action.payload;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchPublicProducts.pending, (state) => {
        state.publicProductsStatus = "loading";
      })
      .addCase(fetchPublicProducts.fulfilled, (state, action) => {
        state.publicProductsStatus = "succeeded";
        state.publicProducts = action.payload;
      })
      .addCase(fetchPublicProducts.rejected, (state, action) => {
        state.publicProductsStatus = "failed";
        state.publicProductError = action.payload;
      })
      .addCase(createProducts.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(deleteProducts.fulfilled, (state) => {
        state.status = "idle";
      })
      .addCase(updateProducts.fulfilled, (state) => {
        state.status = "idle";
      });
    // .addCase(getProductsByCompanyId.fulfilled, (state) => {
    //   state.status = "idle";
    // });
  },
});

export default productsSlice.reducer;
